import type { RouterOutputs } from "@repo/api";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import SectionDialog from "~/components/section/section-dialog";
import { SectionContext } from "~/hooks/use-section";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";

export type Section = RouterOutputs["section"]["getAll"][number];

interface SectionProviderProps {
  children: React.ReactNode;
}

export function SectionProvider({ children }: SectionProviderProps) {
  const { data: sections, isFetching: isSectionsLoading } =
    api.section.getAll.useQuery(undefined, {
      initialData: [],
    });

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isSectionsLoading) {
      setLoadingStage("sections");
    } else {
      setLoadingStage(undefined);
    }
  }, [isSectionsLoading, setLoadingStage]);

  const context = {
    sections,
  };

  return (
    <SectionContext.Provider value={context}>
      {children}
      <SectionDialog />
    </SectionContext.Provider>
  );
}
